// ABOUTME: Custom hook for handling click outside events on DOM elements
// ABOUTME: Provides reusable logic for closing dropdowns, menus, and modals when clicking outside
import { useEffect, useCallback, RefObject } from "react"

interface UseClickOutsideProps {
	refs: RefObject<HTMLElement | null>[]
	isOpen: boolean
	onClose: () => void
}

export const useClickOutside = ({
	refs,
	isOpen,
	onClose,
}: UseClickOutsideProps) => {
	const handleClickOutside = useCallback(
		(e: MouseEvent) => {
			const clickedInsideAnyRef = refs.some(
				ref =>
					ref.current &&
					e.target instanceof Node &&
					ref.current.contains(e.target),
			)

			if (!clickedInsideAnyRef) {
				onClose()
			}
		},
		[refs, onClose],
	)

	useEffect(() => {
		if (!isOpen) return

		document.addEventListener("mousedown", handleClickOutside)
		return () =>
			document.removeEventListener("mousedown", handleClickOutside)
	}, [isOpen, handleClickOutside])
}
